module.exports = __webpack_public_path__ + "img/5.1b871c29.jpg";